import { Paging } from 'types/global'

const allItems = [
  {
    id: '615c5d343571e133e46cd6fe1',
    start: '2021-07-21T00:00:00.000Z',
    createdAt: '2021-07-21T00:00:00.001Z',
    updatedAt: '2021-07-21T00:00:00.000Z',
    end: '2021-07-21T00:00:00.000Z',
    worldTennisNumbers: [
      {
        type: 'SINGLE',
        tennisNumber: 25.82,
        personId: '60a4ed4bbf0fe5a6987890a21',
        __typename: 'MatchUpWorldTennisNumber',
      },
      {
        type: 'SINGLE',
        tennisNumber: 31.71,
        personId: '614c4017f60ae6bf2379793a1',
        __typename: 'MatchUpWorldTennisNumber',
      },
    ],
    winningSide: 'SIDE2',
    score: {
      superTiebreak: {
        winnerPointsWon: 10,
        loserPointsWon: 7,
        __typename: 'Tiebreaker',
      },
      sets: [
        {
          winnerGamesWon: 6,
          loserGamesWon: 0,
          tiebreaker: null,
          __typename: 'Set',
        },
        {
          winnerGamesWon: 6,
          loserGamesWon: 0,
          tiebreaker: null,
          __typename: 'Set',
        },
      ],
      __typename: 'Score',
    },
    status: 'COMPLETED',
    sides: [
      {
        players: [
          {
            person: {
              id: '614c4017f60ae6bf2379793a1',
              nativeGivenName: 'John',
              nativeFamilyName: 'Snow',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/071eac68-4751-4296-903d-3ef566c2f153.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE1',
        __typename: 'Side',
      },
      {
        players: [
          {
            person: {
              id: '60a4ed4bbf0fe5a6987890a21',
              nativeGivenName: 'Cersei',
              nativeFamilyName: 'Lannister',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/572e927f-2767-4af4-9fbf-da0a059bcfa2.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE2',
        __typename: 'Side',
      },
    ],
    type: 'SINGLES',

    __typename: 'MatchUp',
  },
  {
    id: '615c5d343571e133e46cd6fe2',
    start: '2021-07-22T00:00:00.000Z',
    createdAt: '2021-07-21T00:00:00.001Z',
    updatedAt: '2021-07-21T00:00:00.000Z',
    end: '2021-07-22T00:00:00.000Z',
    worldTennisNumbers: [
      {
        type: 'SINGLE',
        tennisNumber: 25.82,
        personId: '60a4ed4bbf0fe5a6987890a21',
        __typename: 'MatchUpWorldTennisNumber',
      },
      {
        type: 'SINGLE',
        tennisNumber: 31.71,
        personId: '614c4017f60ae6bf2379793a1',
        __typename: 'MatchUpWorldTennisNumber',
      },
    ],
    winningSide: 'SIDE1',
    score: {
      superTiebreak: {
        winnerPointsWon: 10,
        loserPointsWon: 7,
        __typename: 'Tiebreaker',
      },
      sets: [
        {
          winnerGamesWon: 6,
          loserGamesWon: 0,
          tiebreaker: null,
          __typename: 'Set',
        },
        {
          winnerGamesWon: 6,
          loserGamesWon: 0,
          tiebreaker: null,
          __typename: 'Set',
        },
      ],
      __typename: 'Score',
    },
    status: 'COMPLETED',
    sides: [
      {
        players: [
          {
            person: {
              id: '614c4017f60ae6bf2379793a1',
              nativeGivenName: 'John',
              nativeFamilyName: 'Snow',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/071eac68-4751-4296-903d-3ef566c2f153.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE1',
        __typename: 'Side',
      },
      {
        players: [
          {
            person: {
              id: '60a4ed4bbf0fe5a6987890a21',
              nativeGivenName: 'Cersei',
              nativeFamilyName: 'Lannister',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/572e927f-2767-4af4-9fbf-da0a059bcfa2.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE2',
        __typename: 'Side',
      },
    ],
    type: 'SINGLES',

    __typename: 'MatchUp',
  },
  {
    id: '615c5d343571e133e46cd6fe3',
    start: '2021-07-23T00:00:00.000Z',
    createdAt: '2021-07-21T00:00:00.001Z',
    updatedAt: '2021-07-21T00:00:00.000Z',
    end: '2021-07-23T00:00:00.000Z',
    worldTennisNumbers: [
      {
        type: 'SINGLE',
        tennisNumber: 25.82,
        personId: '60a4ed4bbf0fe5a6987890a21',
        __typename: 'MatchUpWorldTennisNumber',
      },
      {
        type: 'SINGLE',
        tennisNumber: 31.71,
        personId: '614c4017f60ae6bf2379793a1',
        __typename: 'MatchUpWorldTennisNumber',
      },
    ],
    winningSide: 'SIDE2',
    score: {
      superTiebreak: null,
      sets: [
        {
          winnerGamesWon: 6,
          loserGamesWon: 1,
          tiebreaker: null,
          __typename: 'Set',
        },
        {
          winnerGamesWon: 4,
          loserGamesWon: 6,
          tiebreaker: null,
          __typename: 'Set',
        },
        {
          winnerGamesWon: 6,
          loserGamesWon: 1,
          tiebreaker: null,
          __typename: 'Set',
        },
      ],
      __typename: 'Score',
    },
    status: 'COMPLETED',
    sides: [
      {
        players: [
          {
            person: {
              id: '614c4017f60ae6bf2379793a1',
              nativeGivenName: 'John',
              nativeFamilyName: 'Snow',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/071eac68-4751-4296-903d-3ef566c2f153.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
          {
            person: {
              id: '614c4017f60ae6bf2379793a2',
              nativeGivenName: 'Sansa',
              nativeFamilyName: 'Stark',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/406128df-8199-4ba4-9366-4d276c2f1f59.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE1',
        __typename: 'Side',
      },
      {
        players: [
          {
            person: {
              id: '60a4ed4bbf0fe5a6987890a21',
              nativeGivenName: 'Cersei',
              nativeFamilyName: 'Lannister',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/572e927f-2767-4af4-9fbf-da0a059bcfa2.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
          {
            person: {
              id: '60a4ed4bbf0fe5a6987890a22',
              nativeGivenName: 'Tyrion',
              nativeFamilyName: 'Lannister',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/1f140dc5-c5fd-41dc-8774-3fc1bf9f4f42.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE2',
        __typename: 'Side',
      },
    ],
    type: 'DOUBLES',

    __typename: 'MatchUp',
  },
  {
    id: '615c5d343571e133e46cd6fe4',
    start: '2021-07-24T00:00:00.000Z',
    createdAt: '2021-07-21T00:00:00.001Z',
    updatedAt: '2021-07-21T00:00:00.000Z',
    end: '2021-07-24T00:00:00.000Z',
    worldTennisNumbers: [
      {
        type: 'SINGLE',
        tennisNumber: 25.82,
        personId: '60a4ed4bbf0fe5a6987890a21',
        __typename: 'MatchUpWorldTennisNumber',
      },
      {
        type: 'SINGLE',
        tennisNumber: 31.71,
        personId: '614c4017f60ae6bf2379793a1',
        __typename: 'MatchUpWorldTennisNumber',
      },
    ],
    winningSide: 'SIDE2',
    score: {
      superTiebreak: null,
      sets: [
        {
          winnerGamesWon: 6,
          loserGamesWon: 2,
          tiebreaker: null,
          __typename: 'Set',
        },
        {
          winnerGamesWon: 4,
          loserGamesWon: 6,
          tiebreaker: null,
          __typename: 'Set',
        },
        {
          winnerGamesWon: 6,
          loserGamesWon: 1,
          tiebreaker: null,
          __typename: 'Set',
        },
      ],
      __typename: 'Score',
    },
    status: 'COMPLETED',
    sides: [
      {
        players: [
          {
            person: {
              id: '614c4017f60ae6bf2379793a1',
              nativeGivenName: 'John',
              nativeFamilyName: 'Snow',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/071eac68-4751-4296-903d-3ef566c2f153.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE1',
        __typename: 'Side',
      },
      {
        players: [
          {
            person: {
              id: '60a4ed4bbf0fe5a6987890a21',
              nativeGivenName: 'Cersei',
              nativeFamilyName: 'Lannister',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/572e927f-2767-4af4-9fbf-da0a059bcfa2.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE2',
        __typename: 'Side',
      },
    ],
    type: 'SINGLES',

    __typename: 'MatchUp',
  },
  {
    id: '615c5d343571e133e46cd6fe5',
    start: '2021-07-25T00:00:00.000Z',
    createdAt: '2021-07-21T00:00:00.001Z',
    updatedAt: '2021-07-21T00:00:00.000Z',
    end: '2021-07-25T00:00:00.000Z',
    worldTennisNumbers: [
      {
        type: 'SINGLE',
        tennisNumber: 25.82,
        personId: '60a4ed4bbf0fe5a6987890a21',
        __typename: 'MatchUpWorldTennisNumber',
      },
      {
        type: 'SINGLE',
        tennisNumber: 31.71,
        personId: '614c4017f60ae6bf2379793a1',
        __typename: 'MatchUpWorldTennisNumber',
      },
    ],
    winningSide: 'SIDE2',
    score: {
      superTiebreak: {
        winnerPointsWon: 10,
        loserPointsWon: 7,
        __typename: 'Tiebreaker',
      },
      sets: [
        {
          winnerGamesWon: 6,
          loserGamesWon: 0,
          tiebreaker: null,
          __typename: 'Set',
        },
        {
          winnerGamesWon: 6,
          loserGamesWon: 0,
          tiebreaker: null,
          __typename: 'Set',
        },
      ],
      __typename: 'Score',
    },
    status: 'COMPLETED',
    sides: [
      {
        players: [
          {
            person: {
              id: '614c4017f60ae6bf2379793a1',
              nativeGivenName: 'John',
              nativeFamilyName: 'Snow',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/071eac68-4751-4296-903d-3ef566c2f153.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE1',
        __typename: 'Side',
      },
      {
        players: [
          {
            person: {
              id: '60a4ed4bbf0fe5a6987890a21',
              nativeGivenName: 'Cersei',
              nativeFamilyName: 'Lannister',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/572e927f-2767-4af4-9fbf-da0a059bcfa2.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE2',
        __typename: 'Side',
      },
    ],
    type: 'SINGLES',

    __typename: 'MatchUp',
  },
  {
    id: '615c5d343571e133e46cd6fe6',
    start: '2021-07-26T00:00:00.000Z',
    createdAt: '2021-07-21T00:00:00.001Z',
    updatedAt: '2021-07-21T00:00:00.000Z',
    end: '2021-07-26T00:00:00.000Z',
    worldTennisNumbers: [
      {
        type: 'SINGLE',
        tennisNumber: 25.82,
        personId: '60a4ed4bbf0fe5a6987890a21',
        __typename: 'MatchUpWorldTennisNumber',
      },
      {
        type: 'SINGLE',
        tennisNumber: 31.71,
        personId: '614c4017f60ae6bf2379793a1',
        __typename: 'MatchUpWorldTennisNumber',
      },
    ],
    winningSide: 'SIDE1',
    score: {
      superTiebreak: {
        winnerPointsWon: 10,
        loserPointsWon: 8,
        __typename: 'Tiebreaker',
      },
      sets: [
        {
          winnerGamesWon: 6,
          loserGamesWon: 4,
          tiebreaker: null,
          __typename: 'Set',
        },
        {
          winnerGamesWon: 6,
          loserGamesWon: 6,
          tiebreaker: null,
          __typename: 'Set',
        },
      ],
      __typename: 'Score',
    },
    status: 'COMPLETED',
    sides: [
      {
        players: [
          {
            person: {
              id: '614c4017f60ae6bf2379793a1',
              nativeGivenName: 'John',
              nativeFamilyName: 'Snow',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/071eac68-4751-4296-903d-3ef566c2f153.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
          {
            person: {
              id: '614c4017f60ae6bf2379793a2',
              nativeGivenName: 'Sansa',
              nativeFamilyName: 'Stark',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/406128df-8199-4ba4-9366-4d276c2f1f59.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE1',
        __typename: 'Side',
      },
      {
        players: [
          {
            person: {
              id: '60a4ed4bbf0fe5a6987890a21',
              nativeGivenName: 'Cersei',
              nativeFamilyName: 'Lannister',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/572e927f-2767-4af4-9fbf-da0a059bcfa2.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
          {
            person: {
              id: '60a4ed4bbf0fe5a6987890a22',
              nativeGivenName: 'Tyrion',
              nativeFamilyName: 'Lannister',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/1f140dc5-c5fd-41dc-8774-3fc1bf9f4f42.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE2',
        __typename: 'Side',
      },
    ],
    type: 'DOUBLES',

    __typename: 'MatchUp',
  },
  {
    id: '615c5d343571e133e46cd6fe7',
    start: '2021-07-27T00:00:00.000Z',
    createdAt: '2021-07-21T00:00:00.001Z',
    updatedAt: '2021-07-21T00:00:00.000Z',
    end: '2021-07-27T00:00:00.000Z',
    worldTennisNumbers: [
      {
        type: 'SINGLE',
        tennisNumber: 25.82,
        personId: '60a4ed4bbf0fe5a6987890a21',
        __typename: 'MatchUpWorldTennisNumber',
      },
      {
        type: 'SINGLE',
        tennisNumber: 31.71,
        personId: '614c4017f60ae6bf2379793a1',
        __typename: 'MatchUpWorldTennisNumber',
      },
    ],
    winningSide: 'SIDE2',
    score: {
      superTiebreak: {
        winnerPointsWon: 10,
        loserPointsWon: 7,
        __typename: 'Tiebreaker',
      },
      sets: [
        {
          winnerGamesWon: 6,
          loserGamesWon: 0,
          tiebreaker: null,
          __typename: 'Set',
        },
        {
          winnerGamesWon: 6,
          loserGamesWon: 0,
          tiebreaker: null,
          __typename: 'Set',
        },
      ],
      __typename: 'Score',
    },
    status: 'COMPLETED',
    sides: [
      {
        players: [
          {
            person: {
              id: '614c4017f60ae6bf2379793a1',
              nativeGivenName: 'John',
              nativeFamilyName: 'Snow',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/071eac68-4751-4296-903d-3ef566c2f153.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE1',
        __typename: 'Side',
      },
      {
        players: [
          {
            person: {
              id: '60a4ed4bbf0fe5a6987890a21',
              nativeGivenName: 'Cersei',
              nativeFamilyName: 'Lannister',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/572e927f-2767-4af4-9fbf-da0a059bcfa2.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE2',
        __typename: 'Side',
      },
    ],
    type: 'SINGLES',

    __typename: 'MatchUp',
  },
  {
    id: '615c5d343571e133e46cd6fe8',
    start: '2021-07-28T00:00:00.000Z',
    createdAt: '2021-07-21T00:00:00.001Z',
    updatedAt: '2021-07-21T00:00:00.000Z',
    end: '2021-07-28T00:00:00.000Z',
    worldTennisNumbers: [
      {
        type: 'SINGLE',
        tennisNumber: 25.82,
        personId: '60a4ed4bbf0fe5a6987890a21',
        __typename: 'MatchUpWorldTennisNumber',
      },
      {
        type: 'SINGLE',
        tennisNumber: 31.71,
        personId: '614c4017f60ae6bf2379793a1',
        __typename: 'MatchUpWorldTennisNumber',
      },
    ],
    winningSide: 'SIDE1',
    score: {
      superTiebreak: {
        winnerPointsWon: 10,
        loserPointsWon: 7,
        __typename: 'Tiebreaker',
      },
      sets: [
        {
          winnerGamesWon: 6,
          loserGamesWon: 0,
          tiebreaker: null,
          __typename: 'Set',
        },
        {
          winnerGamesWon: 6,
          loserGamesWon: 0,
          tiebreaker: null,
          __typename: 'Set',
        },
      ],
      __typename: 'Score',
    },
    status: 'COMPLETED',
    sides: [
      {
        players: [
          {
            person: {
              id: '614c4017f60ae6bf2379793a1',
              nativeGivenName: 'John',
              nativeFamilyName: 'Snow',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/071eac68-4751-4296-903d-3ef566c2f153.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE1',
        __typename: 'Side',
      },
      {
        players: [
          {
            person: {
              id: '60a4ed4bbf0fe5a6987890a21',
              nativeGivenName: 'Cersei',
              nativeFamilyName: 'Lannister',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/572e927f-2767-4af4-9fbf-da0a059bcfa2.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE2',
        __typename: 'Side',
      },
    ],
    type: 'SINGLES',

    __typename: 'MatchUp',
  },
  {
    id: '615c5d343571e133e46cd6fe9',
    start: '2021-07-29T00:00:00.000Z',
    createdAt: '2021-07-21T00:00:00.001Z',
    updatedAt: '2021-07-21T00:00:00.000Z',
    end: '2021-07-29T00:00:00.000Z',
    worldTennisNumbers: [
      {
        type: 'SINGLE',
        tennisNumber: 25.82,
        personId: '60a4ed4bbf0fe5a6987890a21',
        __typename: 'MatchUpWorldTennisNumber',
      },
      {
        type: 'SINGLE',
        tennisNumber: 31.71,
        personId: '614c4017f60ae6bf2379793a1',
        __typename: 'MatchUpWorldTennisNumber',
      },
    ],
    winningSide: 'SIDE2',
    score: {
      superTiebreak: null,
      sets: [
        {
          winnerGamesWon: 6,
          loserGamesWon: 1,
          tiebreaker: null,
          __typename: 'Set',
        },
        {
          winnerGamesWon: 4,
          loserGamesWon: 6,
          tiebreaker: null,
          __typename: 'Set',
        },
        {
          winnerGamesWon: 6,
          loserGamesWon: 1,
          tiebreaker: null,
          __typename: 'Set',
        },
      ],
      __typename: 'Score',
    },
    status: 'COMPLETED',
    sides: [
      {
        players: [
          {
            person: {
              id: '614c4017f60ae6bf2379793a1',
              nativeGivenName: 'John',
              nativeFamilyName: 'Snow',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/071eac68-4751-4296-903d-3ef566c2f153.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
          {
            person: {
              id: '614c4017f60ae6bf2379793a2',
              nativeGivenName: 'Sansa',
              nativeFamilyName: 'Stark',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/406128df-8199-4ba4-9366-4d276c2f1f59.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE1',
        __typename: 'Side',
      },
      {
        players: [
          {
            person: {
              id: '60a4ed4bbf0fe5a6987890a21',
              nativeGivenName: 'Cersei',
              nativeFamilyName: 'Lannister',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/572e927f-2767-4af4-9fbf-da0a059bcfa2.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
          {
            person: {
              id: '60a4ed4bbf0fe5a6987890a22',
              nativeGivenName: 'Tyrion',
              nativeFamilyName: 'Lannister',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/1f140dc5-c5fd-41dc-8774-3fc1bf9f4f42.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE2',
        __typename: 'Side',
      },
    ],
    type: 'DOUBLES',

    __typename: 'MatchUp',
  },
  {
    id: '615c5d343571e133e46cd6fe10',
    start: '2021-07-30T00:00:00.000Z',
    createdAt: '2021-07-21T00:00:00.001Z',
    updatedAt: '2021-07-21T00:00:00.000Z',
    end: '2021-07-30T00:00:00.000Z',
    worldTennisNumbers: [
      {
        type: 'SINGLE',
        tennisNumber: 25.82,
        personId: '60a4ed4bbf0fe5a6987890a21',
        __typename: 'MatchUpWorldTennisNumber',
      },
      {
        type: 'SINGLE',
        tennisNumber: 31.71,
        personId: '614c4017f60ae6bf2379793a1',
        __typename: 'MatchUpWorldTennisNumber',
      },
    ],
    winningSide: 'SIDE2',
    score: {
      superTiebreak: null,
      sets: [
        {
          winnerGamesWon: 6,
          loserGamesWon: 2,
          tiebreaker: null,
          __typename: 'Set',
        },
        {
          winnerGamesWon: 4,
          loserGamesWon: 6,
          tiebreaker: null,
          __typename: 'Set',
        },
        {
          winnerGamesWon: 6,
          loserGamesWon: 1,
          tiebreaker: null,
          __typename: 'Set',
        },
      ],
      __typename: 'Score',
    },
    status: 'COMPLETED',
    sides: [
      {
        players: [
          {
            person: {
              id: '614c4017f60ae6bf2379793a1',
              nativeGivenName: 'John',
              nativeFamilyName: 'Snow',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/071eac68-4751-4296-903d-3ef566c2f153.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE1',
        __typename: 'Side',
      },
      {
        players: [
          {
            person: {
              id: '60a4ed4bbf0fe5a6987890a21',
              nativeGivenName: 'Cersei',
              nativeFamilyName: 'Lannister',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/572e927f-2767-4af4-9fbf-da0a059bcfa2.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE2',
        __typename: 'Side',
      },
    ],
    type: 'SINGLES',

    __typename: 'MatchUp',
  },
  {
    id: '615c5d343571e133e46cd6fe11',
    start: '2021-07-31T00:00:00.000Z',
    createdAt: '2021-07-21T00:00:00.001Z',
    updatedAt: '2021-07-21T00:00:00.000Z',
    end: '2021-07-31T00:00:00.000Z',
    worldTennisNumbers: [
      {
        type: 'SINGLE',
        tennisNumber: 25.82,
        personId: '60a4ed4bbf0fe5a6987890a21',
        __typename: 'MatchUpWorldTennisNumber',
      },
      {
        type: 'SINGLE',
        tennisNumber: 31.71,
        personId: '614c4017f60ae6bf2379793a1',
        __typename: 'MatchUpWorldTennisNumber',
      },
    ],
    winningSide: 'SIDE2',
    score: {
      superTiebreak: {
        winnerPointsWon: 10,
        loserPointsWon: 7,
        __typename: 'Tiebreaker',
      },
      sets: [
        {
          winnerGamesWon: 6,
          loserGamesWon: 0,
          tiebreaker: null,
          __typename: 'Set',
        },
        {
          winnerGamesWon: 6,
          loserGamesWon: 0,
          tiebreaker: null,
          __typename: 'Set',
        },
      ],
      __typename: 'Score',
    },
    status: 'COMPLETED',
    sides: [
      {
        players: [
          {
            person: {
              id: '614c4017f60ae6bf2379793a1',
              nativeGivenName: 'John',
              nativeFamilyName: 'Snow',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/071eac68-4751-4296-903d-3ef566c2f153.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE1',
        __typename: 'Side',
      },
      {
        players: [
          {
            person: {
              id: '60a4ed4bbf0fe5a6987890a21',
              nativeGivenName: 'Cersei',
              nativeFamilyName: 'Lannister',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/572e927f-2767-4af4-9fbf-da0a059bcfa2.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE2',
        __typename: 'Side',
      },
    ],
    type: 'SINGLES',

    __typename: 'MatchUp',
  },
  {
    id: '615c5d343571e133e46cd6fe12',
    start: '2021-08-01T00:00:00.000Z',
    createdAt: '2021-07-21T00:00:00.001Z',
    updatedAt: '2021-07-21T00:00:00.000Z',
    end: '2021-08-01T00:00:00.000Z',
    worldTennisNumbers: [
      {
        type: 'SINGLE',
        tennisNumber: 25.82,
        personId: '60a4ed4bbf0fe5a6987890a21',
        __typename: 'MatchUpWorldTennisNumber',
      },
      {
        type: 'SINGLE',
        tennisNumber: 31.71,
        personId: '614c4017f60ae6bf2379793a1',
        __typename: 'MatchUpWorldTennisNumber',
      },
    ],
    winningSide: 'SIDE1',
    score: {
      superTiebreak: {
        winnerPointsWon: 10,
        loserPointsWon: 8,
        __typename: 'Tiebreaker',
      },
      sets: [
        {
          winnerGamesWon: 6,
          loserGamesWon: 4,
          tiebreaker: null,
          __typename: 'Set',
        },
        {
          winnerGamesWon: 6,
          loserGamesWon: 6,
          tiebreaker: null,
          __typename: 'Set',
        },
      ],
      __typename: 'Score',
    },
    status: 'COMPLETED',
    sides: [
      {
        players: [
          {
            person: {
              id: '614c4017f60ae6bf2379793a1',
              nativeGivenName: 'John',
              nativeFamilyName: 'Snow',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/071eac68-4751-4296-903d-3ef566c2f153.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
          {
            person: {
              id: '614c4017f60ae6bf2379793a2',
              nativeGivenName: 'Sansa',
              nativeFamilyName: 'Stark',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/406128df-8199-4ba4-9366-4d276c2f1f59.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE1',
        __typename: 'Side',
      },
      {
        players: [
          {
            person: {
              id: '60a4ed4bbf0fe5a6987890a21',
              nativeGivenName: 'Cersei',
              nativeFamilyName: 'Lannister',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/572e927f-2767-4af4-9fbf-da0a059bcfa2.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
          {
            person: {
              id: '60a4ed4bbf0fe5a6987890a22',
              nativeGivenName: 'Tyrion',
              nativeFamilyName: 'Lannister',
              nationalityCode: 'USA',
              biographicalInformation: {
                avatarUrl:
                  'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/1f140dc5-c5fd-41dc-8774-3fc1bf9f4f42.png',
                __typename: 'BiographicalInformation',
              },
              optedOutOfPublicDataConsent: false,
              __typename: 'Person',
            },
            playerNumber: null,
            __typename: 'Player',
          },
        ],
        sideNumber: 'SIDE2',
        __typename: 'Side',
      },
    ],
    type: 'DOUBLES',
    __typename: 'MatchUp',
  },
]

export const getApprovedMatches = ({ limit = 0, skip = 0 }: Paging) => {
  return {
    paginated: {
      id: '614c4017f60ae6bf2379793a1',
      matchUps: {
        items: allItems.slice(skip, skip + limit),
        totalItems: allItems.length,
        __typename: 'MatchUpList',
      },
      __typename: 'Person',
    },
    recentlyUpdated: {
      id: '614c4017f60ae6bf2379793a1',
      matchUps: {
        items: [],
        __typename: 'MatchUpList',
      },
      __typename: 'Person',
    },
  }
}
